import SingularCase from "./SingularCase";

export default SingularCase;
